import React from 'react'
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Dialog from "@material-ui/core/Dialog";

class HistoricPqrs extends React.Component {

    render() {
        const {historic, codePqr, open, onClose} = this.props;

        return (
            <Dialog
                fullWidth={true}
                maxWidth='md'
                open={open}
                onClose={onClose}
                aria-labelledby="max-width-dialog-title"
            >
                <DialogTitle id="max-width-dialog-title">Trazabilidad - PQR No. {codePqr}</DialogTitle>
                <DialogContent>
                    <table className='custom-table'>
                        <thead>
                        <tr>
                            <th>Fecha</th>
                            <th>Descripción</th>
                        </tr>
                        </thead>
                        <tbody>

                        {historic.map((val, index) => {
                            return (
                                <tr key={index}>
                                    <td>{val.fecha_registro}</td>
                                    <td>{val.observaciones}</td>
                                </tr>
                            );
                        })}

                        </tbody>
                    </table>
                </DialogContent>
            </Dialog>
        );
    }
}

export default HistoricPqrs